import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import LoginSidebar from 'components/consumer/LoginSidebar/LoginSidebar';
import CtaLink from 'components/essentials/Cta/CtaLink';
import isClient from 'commons/isClient';
import useUserData from 'data-hooks/useUserData';
const ConsumerLoginSideBarLink = () => {
  const $ = _c(5);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const {
    isLoggedIn,
    loading
  } = useUserData();
  if (loading) {
    return null;
  }
  if (isLoggedIn) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Redirect to="/customer/orders" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CtaLink to="/sign-in/" color="brand" size="sm" hasArrow={true} onClick={evt => {
      if (isClient()) {
        evt.preventDefault();
        setSidebarOpen(true);
      }
    }}>{" "}Sign In to track your order</CtaLink>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setSidebarOpen(false);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isSidebarOpen) {
    t2 = <>{t0}<LoginSidebar show={isSidebarOpen} onClose={t1} /></>;
    $[3] = isSidebarOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default ConsumerLoginSideBarLink;